var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content-container container-fluid px-12"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"loader":'dots',"height":150,"width":150,"color":'#F1557A',"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_c('v-dialog'),_vm._m(0),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card card-small mb-12"},[_c('vue-good-table',{staticClass:"card-style",attrs:{"columns":_vm.columns,"rows":_vm.rows,"styleClass":"vgt-table striped condensed","search-options":{
            enabled: false,
            skipDiacritics: true,
            // searchFn: mySearchFn,
            placeholder: 'Search your base',
            externalQuery: _vm.searchQuery
          },"sort-options":{
            enabled: true,
            initialSortBy: [{ field: 'createdAt', type: 'asc' }]
          },"pagination-options":{
            enabled: true,
            mode: 'records',
            perPage: 20,
            position: 'top',
            perPageDropdown: [20, 40, 60],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Doantions per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All'
          },"selectOptions":{
            enabled: false,
            selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: false // disable the select info panel on top
          }},on:{"on-row-click":_vm.onRowClick,"on-select-all":_vm.onSelectAll}})],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header row no-gutters py-4"},[_c('div',{staticClass:"col-lg-12 col-sm-4 text-center text-sm-left mb-0"},[_c('h3',{staticClass:"page-title"},[_vm._v("Donations")])])])}]

export { render, staticRenderFns }